import { useParams } from "react-router-dom";
import { isTaskShelfSize } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { ShelfSizePage } from "./ShelfSizePage";

const ShelfSize = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskShelfSize(currentTask) || !currentPoint)
        return <NotFound />;

    return <ShelfSizePage point={currentPoint} task={currentTask} />;
};

export default ShelfSize;
